import { SanityBlogPostBody } from '@data/sanity/queries/types/modules'

import ComplexPortableText from '@components/portable-text/complex'

interface BlogPostBodyProps {
  content: SanityBlogPostBody['content']
}

const BlogPostBody = ({ content }: BlogPostBodyProps) => {
  return (
    <section className="container flex flex-col justify-center items-center mb-12">
      <ComplexPortableText
        content={content}
        className="rc rc-blog-post before:content-[''] before:block before:mb-12 before:lg:mb-20"
      />
    </section>
  )
}

export default BlogPostBody
